import {FunctionComponent, ComponentChildren } from 'preact';
import { useRef } from 'preact/hooks';

import styles from './styles.module.scss';

interface Props {
  className?: string;
  children?: ComponentChildren;
  onClose: (evt: MouseEvent) => void;
  anchorEl?: HTMLElement;
  overlay?: boolean
}

export const getArrowPosition = ($popoverRef: HTMLElement, $anchorEl: HTMLElement): number => {
  try {
    if (!$popoverRef || !$anchorEl) return null;
    const popoverRect = $popoverRef.getBoundingClientRect();
    const elementRect = $anchorEl.getBoundingClientRect();
    return elementRect.y - popoverRect.y;
  } catch (e) {
    console.error('getArrowPosition', e);
    return null;
  }
};

const Popover: FunctionComponent<Props> = ({
  className,
  onClose,
  anchorEl,
  children,
  overlay = true,
}: Props) => {
  const $popoverRef = useRef<HTMLElement>();

  const arrowPosition = $popoverRef.current ? getArrowPosition($popoverRef.current, anchorEl) : null;

  return (
    <div className={`${styles.universalPopover}`}>
      {overlay && <div className={styles.overlay} onClick={onClose} />}

      <section className={`${styles.popover} ${className || ''}`} ref={$popoverRef}>
        {arrowPosition && (
          <div
            className={`${styles.arrow} ${styles.arrowRight}`}
            style={{ top: arrowPosition + 6 }}
          />
        )}

        {children}
      </section>
    </div>
  );
};

export default Popover;
